// @flow
import { useMemo } from 'react'
import { prop, path, map, pipe, when, complement, always, omit } from 'ramda'

import { useFilterData } from 'app/common/ui-components/filter'
import filterBuilding from 'app/components/common/reports/filters/building'

import type { Limits, OOPGenerateParams } from './OOPGenerateParams'


const toInt = (val: string) => parseInt(val, 10)

export default function useFilterParams(foodModeEnable: boolean, orgId: number): OOPGenerateParams | null {
  const [{ applied: filterApplied }] = useFilterData()

  const result: OOPGenerateParams | null = useMemo(() => {
    if (!filterApplied) {
      return null
    }
    const limits: Limits = pipe(
      when<any, any>(complement(always(foodModeEnable)), omit(['food_mode'])),
    )({
      klasses_ids: map(toInt, prop('class', filterApplied)),
      statuses: map(toInt, prop('status', filterApplied)),
      food_modes: prop('foodMode', filterApplied),
      building_id: prop(filterBuilding, filterApplied),
    })

    return ({
      from: path(['period', 0], filterApplied),
      to: path(['period', 1], filterApplied),
      school_id: orgId,
      limits,
      details_group: prop('detailsGroup', filterApplied)[0] as 'by_complexes' | 'by_klasses',
    })
  }, [filterApplied, foodModeEnable, orgId])


  return result
}
